import React from 'react';
import { REGEX_MENCAO_ARQUIVO } from './repoDocMencoes';

/**
 * Renderiza texto de documentação com menções [[arquivo:ID|caminho]] clicáveis.
 */
export default function RepoConteudoDoc({ conteudo, mencoes = [], onClickMencao }) {
  if (conteudo == null || conteudo === '') {
    return <p className="repo-doc-vazio text-muted small mb-0">Sem conteúdo. Use &quot;Editar&quot; para descrever como este arquivo funciona.</p>;
  }

  const mapa = new Map((mencoes || []).map((m) => [Number(m.arquivo_id), m]));
  const str = String(conteudo);
  const nos = [];
  let ultimo = 0;
  let i = 0;
  const re = new RegExp(REGEX_MENCAO_ARQUIVO.source, 'g');
  let m;

  while ((m = re.exec(str)) !== null) {
    if (m.index > ultimo) nos.push(<span key={`t-${i}`}>{str.slice(ultimo, m.index)}</span>);
    const arquivoId = parseInt(m[1], 10);
    const label = (m[2] || '').trim() || mapa.get(arquivoId)?.caminho || `arquivo #${arquivoId}`;
    const info = mapa.get(arquivoId);
    const temDoc = info ? !!info.tem_doc : true;
    nos.push(
      <button
        key={`m-${i++}`}
        type="button"
        className={`repo-doc-mencao ${temDoc ? '' : 'repo-doc-mencao--sem-doc'}`}
        title={temDoc ? 'Abrir documentação deste arquivo' : 'Arquivo sem documentação ainda'}
        onClick={() => onClickMencao && onClickMencao(arquivoId)}
      >
        @{label}
      </button>
    );
    ultimo = re.lastIndex;
  }
  if (ultimo < str.length) nos.push(<span key={`t-${i}`}>{str.slice(ultimo)}</span>);

  return <div className="repo-doc-conteudo">{nos.length ? nos : str}</div>;
}
